import React, { useEffect } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import 'antd/dist/antd.css';
import './App.scss';

import PrivateRouter from './components/routes/private-route';
import Login from './pages/login';
import ResetPassword from './pages/resetPassword';
import BaseLayout from './components/base-layout/base';
import Authenticate from './pages/authenticate';
import Logout from './pages/logout';
import NotFound from './pages/404';
import Ticket from './pages/ticket';
import TicketDetail from './pages/ticket-detail';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from './store/actions/authenticate';
import config from '@/config';
import RequestResetPassword from '@/pages/requestResetPassword';

function App() {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.authenticate.isLogin);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  useEffect(() => {
    if (isLogin && window.location.pathname === `${config.contextPath}/login`) {
      window.location.href = `${config.contextPath}/`;
    }
  }, [isLogin]);

  return (
    <Router>
      <BaseLayout>
        <Switch>
          <Route path={`${config.contextPath}/login`} render={() => <Login />} />
          <Route
            path={`${config.contextPath}/request-reset-password`}
            render={() => <RequestResetPassword />}
          />
          <Route path={`${config.contextPath}/reset-password`} render={() => <ResetPassword />} />
          <Route path={`${config.contextPath}/auth/redirect`} render={() => <Authenticate />} />
          <Route path={`${config.contextPath}/auth/logout`} render={() => <Logout />} />
          <PrivateRouter
            path={`${config.contextPath}/ticket/:id`}
            render={() => <TicketDetail />}
          />
          <PrivateRouter path={`${config.contextPath}/ticket`} render={() => <Ticket />} />
          <PrivateRouter exact path={`${config.contextPath}/`} render={() => <Ticket />} />
          <Route path={`${config.contextPath}/404`} component={NotFound} />
          <Redirect from="*" to={`${config.contextPath}/404`} />
        </Switch>
      </BaseLayout>
    </Router>
  );
}

export default App;
